export interface IResponsibleGamingState {
    /**
     * If the user needs to set the betting limits
     */
    requireBettingLimit: boolean | null;
}

export const RESPONSIBLE_GAMING_NAMESPACE = 'responsible_gaming';
export const SET_REQUIRE_BETTING_LIMIT = 'SET_REQUIRE_BETTING_LIMIT';
